import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import totalDriverIcon from "packages/novous_web/src/assets/icons/totalDriver.svg";
import availableDriverIcon from "packages/novous_web/src/assets/icons/availableDriver.svg";
import infoIcon from "packages/novous_web/src/assets/icons/i.svg";
import { IconButton } from "@mui/material";

type ColumnObjType = {
    [key: string]: {
        name: string;
        status: boolean;
    };
};


const DriverCoachingPlaylistTiles = ({ alertState }: { alertState: any }) => {
    return (
        <div className="w-full flex gap-4">
            <Paper
                sx={{ borderRadius: "12px", flex: 1/3 }}
                className="border border-[#f0eff8] p-4 flex flex-col gap-1 items-start"
            >
                <div className="flex items-center gap-2 w-full">
                    <IconButton sx={(theme) => ({
                        background: theme.palette.selected,
                        padding: '4px'
                    })}>
                        <img src={totalDriverIcon} alt="icon" color="primary" />
                    </IconButton>
                    <div className="flex flex-1 min-w-0 flex-col justify-start gap-1">
                        <Typography
                            variant="button"
                            fontWeight={400}
                            noWrap
                            sx={{
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                maxWidth: "100%"
                            }}
                        >
                            Date Shared
                        </Typography>
                    </div>

                    <img
                        src={infoIcon}
                        alt="info icon"
                        title="More info"
                        className="w-4 h-4 cursor-pointer"
                    />
                </div>
                <div className="flex items-center w-full gap-2 flex-nowrap">
                    {/* <div className="invisible w-6 h-6">
                        {tile.icon}
                    </div> */}
                    <Typography
                        variant="h6"
                        fontWeight={600}
                        className="flex-grow px-2 w-full whitespace-nowrap overflow-hidden text-ellipsis"
                    >
                        {alertState?.createdAt &&
                            new Intl.DateTimeFormat("en-GB", {
                                day: "2-digit",
                                month: "long",
                                year: "numeric",
                            }).format(new Date(alertState.createdAt.replace(":", "T")))
                        }
                    </Typography>
                </div>
            </Paper>
            <Paper
                sx={{ borderRadius: "12px", flex: 1/3 }}
                className="border border-[#f0eff8] p-4 flex flex-col gap-1 items-start"
            >
                <div className="flex items-center gap-2 w-full">
                    <IconButton sx={(theme) => ({
                        background: theme.palette.selected,
                        padding: '4px'
                    })}>
                        <img src={availableDriverIcon} alt="icon" color="primary" />
                    </IconButton>
                    <div className="flex flex-1 min-w-0 flex-col justify-start gap-1">
                        <Typography
                            variant="button"
                            fontWeight={400}
                            noWrap
                            sx={{
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                maxWidth: "100%"
                            }}
                        >
                            Completion
                        </Typography>
                    </div>

                    <img
                        src={infoIcon}
                        alt="info icon"
                        title="More info"
                        className="w-4 h-4 cursor-pointer"
                    />
                </div>
                <div className="flex items-center w-full gap-2 flex-nowrap">
                    {/* <div className="invisible w-6 h-6">
                        {tile.icon}
                    </div> */}
                    <Typography
                        variant="h6"
                        fontWeight={600}
                        className="flex-grow px-2 w-full whitespace-nowrap overflow-hidden text-ellipsis"
                    >
                        {alertState?.progressPercentage}%
                    </Typography>
                </div>
            </Paper>
            <Paper
                sx={{ borderRadius: "12px", flex: 1 }}
                className="border border-[#f0eff8] p-4 flex flex-col gap-1 items-start"
            >
                <div className="flex items-center gap-2 w-full">
                    <IconButton sx={(theme) => ({
                        background: theme.palette.selected,
                        padding: '4px'
                    })}>
                        <img src={totalDriverIcon} alt="icon" color="primary" />
                    </IconButton>
                    <div className="flex flex-1 min-w-0 flex-col justify-start gap-1">
                        <Typography
                            variant="button"
                            fontWeight={400}
                            noWrap
                            sx={{
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                maxWidth: "100%"
                            }}
                        >
                            Alert Events
                        </Typography>
                    </div>

                    <img
                        src={infoIcon}
                        alt="info icon"
                        title="More info"
                        className="w-4 h-4 cursor-pointer"
                    />
                </div>
                <div className="grid grid-cols-4 w-full items-center gap-2 pt-2">
                    <div className="flex items-center w-full gap-2 flex-nowrap bg-[#EEEDFC] rounded-[8px] px-4 h-[24px] justify-center">
                        {/* <div className="invisible w-6 h-6">
                        {tile.icon}
                    </div> */}
                        <Typography
                            variant="body2"
                            fontWeight={400}
                            className="flex-grow px-2 w-full whitespace-nowrap overflow-hidden text-ellipsis"
                        >
                            {alertState?.alertName}
                        </Typography>
                    </div>
                </div>
            </Paper>
        </div>
    );
};

export default DriverCoachingPlaylistTiles;
